import styled from "styled-components";

/*
 * The look of the WHG Docs panel inside Word, shared by the pane and its
 * tabs. Word's task pane is narrow (about 320px), so everything stacks.
 */

export const Pane = styled.div`
  font-family: "Segoe UI", "Manrope", sans-serif;
  font-size: 13px;
  color: #0f172a;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-weight: 800;
  color: #5b21b6;
  letter-spacing: -0.01em;
`;

export const Small = styled.div`
  font-size: 12px;
  color: #64748b;
  line-height: 1.45;
`;

export const Section = styled.section`
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #475569;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e2e8f0;
`;

export const Tab = styled.button`
  flex: 1;
  border: 0;
  background: none;
  padding: 8px 4px;
  font-weight: 700;
  font-size: 12px;
  color: ${(p) => (p.$active ? "#1e40af" : "#64748b")};
  border-bottom: 2px solid ${(p) => (p.$active ? "#1e40af" : "transparent")};
  cursor: pointer;
`;

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 7px 9px;
  font-size: 13px;
`;

export const Select = styled.select`
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 7px 9px;
  font-size: 13px;
  background: #fff;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 40vh;
  overflow: auto;
`;

export const Row = styled.button`
  text-align: left;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  padding: 7px 9px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #f8fafc;
  }
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
  background: ${(p) => (p.$mapped ? "#16a34a" : "#d97706")};
`;

export const RowText = styled.div`
  min-width: 0;
  flex: 1;
  strong {
    display: block;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    display: block;
    font-size: 11px;
    color: #64748b;
  }
`;

export const Button = styled.button`
  border: 1px solid #cbd5e1;
  background: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: #0f172a;
  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
`;

export const Primary = styled(Button)`
  background: #1e40af;
  border-color: #1e40af;
  color: #fff;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
`;

export const Notice = styled.div`
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  background: ${(p) => p.$bg || "#f1f5f9"};
  color: ${(p) => p.$fg || "#334155"};
`;

export const Toggle = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  cursor: pointer;
`;
